<template>
  <div class="dropdown">
    <label class="form-label d-block d-lg-block" :class="{'d-none d-md-block': !store.mobileSearch}">{{ $t('catalog.sort_by') }}</label>
    <button class="btn btn-outline-primary w-auto dropdown-toggle" type="button" id="catalog_filter_sort" data-bs-toggle="dropdown" aria-expanded="false">
      <span class="d-inline-block">{{ $t(store.sortingLabel) }}</span>
    </button>
    <ul class="dropdown-menu" aria-labelledby="catalog_filter_sort">
      <li v-for="(name, key) in store.sortingOptions" data-name="sorting" :data-value="key">
        <a class="dropdown-item" href="javascript:void(0)" @click="store.setSorting(key)">{{ $t(name) }}</a>
      </li>
    </ul>
  </div>
</template>

<script setup>
import {useCatalogStore} from "~/stores/CatalogStore.js";

const store = useCatalogStore();
</script>
